var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"marketplace left"},[_c('img',{staticStyle:{"margin-bottom":"30px"},attrs:{"src":require("../assets/prodotto.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }